const equipmentData = {
  products: [
    {
      id: 0,
      name: "PACK SOLAIRE AUTONOME 1.000WH",
      description: "Description for package product test",
      puissance: 1000,
      image: "./images/pack eco.jpeg"
    },
    {
      id: 1,
      name: "PACK SOLAIRE AUTONOME 2.000WH",
      description: "Description for package product test",
      puissance: 2000,
      image: "./images/pack eco.jpeg"
    },
    {
      id: 2,
      name: "⁠PACK SOLAIRE AUTONOME 3.000WH",
      description: "Description for package product test",
      puissance: 3000,
      image: "./images/PACK PRO.jpg"
    },
    {
      id: 3,
      name: "⁠PACK SOLAIRE AUTONOME 4.000WH",
      description: "Description for package product test",
      puissance: 4000,
      image: "./images/PACK PRO.jpg"
    },
    {
      id: 4,
      name: "PACK SOLAIRE AUTONOME 6.000WH",
      description: "Description for package product test",
      puissance: 6000,
      image: "./images/PACK PRO.jpg"
    },
    {
      id: 5,
      name: "PACK SOLAIRE AUTONOME 8.000WH",
      description: "Description for package product test",
      puissance: 8000,
      image: "./images/PACK PRO.jpg"
    },
    {
      id: 6,
      name: "⁠PACK SOLAIRE AUTONOME 10.000WH",
      description: "Description for package product test",
      puissance: 10000,
      image: "./images/PACK PRO.jpg"
    },
    {
      id: 7,
      name: "⁠PACK SOLAIRE AUTONOME 15.000WH",
      description: "Description for package product test",
      puissance: 15000,
      image: "./images/PACK-PRO-LITHIUM.jpg"
    },
    {
      id: 8,
      name: "⁠PACK SOLAIRE AUTONOME 20.000WH",
      description: "Description for package product test",
      puissance: 20000,
      image: "./images/PACK-PRO-LITHIUM.jpg"
    },
    {
      id: 9,
      name: "⁠PACK SOLAIRE AUTONOME 30.000WH",
      description: "Description for package product test",
      puissance: 30000,
      image: "./images/PACK-PRO-LITHIUM.jpg"
    }
  ],
  equipments: [
    {
      id: 0,
      name: "Éclairage",
      image: "./images/bulb.png",
      multipleQuantity: true,
      quantity: 1,
      usage: 0,
      selectedOption: {},
      options: [
        {
          id: 0,
          name: "Ampoules / Spot LED 3W",
          image: "./images/bulb.png",
          watt: 3
        }, 
        {
          id: 1,
          name: "Ampoules / Spot LED 5W",
          image: "./images/bulb.png",
          watt: 5
        }, 
        {
          id: 2,
          name: "Ampoules / Spot LED 7W",
          image: "./images/bulb.png",
          watt: 7
        }, 
        {
          id: 3,
          name: "Ampoules / Spot LED 10W",
          image: "./images/bulb.png",
          watt: 10
        }, 
        {
          id: 4,
          name: "Réglettes LED 18W",
          image: "./images/reglettes.png",
          watt: 18
        }, 
        {
          id: 5,
          name: "Dalles LED 40W",
          image: "./images/dalle.png",
          watt: 40
        }
      ]
    },
    {
      id: 1,
      name: "Téléphonie & PC",
      image: "./images/tab.png",
      puissance: 200,
      multipleQuantity: true,
      quantity: 1,
      usage: 0,
      selectedOption: {},
      options: [
        {
          id: 0,
          name: "Chargeur Smartphone 5W",
          image: "./images/chargeur.png",
          watt: 5
        }, 
        {
          id: 1,
          name: "Chargeur Tablette 10W",
          image: "./images/tablette.png",
          watt: 10
        }, 
        {
          id: 2,
          name: "PC PORTABLE 50W",
          image: "./images/portable.png",
          watt: 50
        }, 
        {
          id: 3,
          name: "PC BUREAU 120W",
          image: "./images/pcbureau.png",
          watt: 120
        }, 
        {
          id: 4,
          name: "PC BUREAU 200W",
          image: "./images/pcgaming.png",
          watt: 200
        }, 
        {
          id: 5,
          name: "Box internet 20W",
          image: "./images/boxinternet.png",
          watt: 20
        }, 
        {
          id: 6,
          name: "Imprimante jet d'encre 150W",
          image: "./images/printer1.png",
          watt: 150
        }, 
        {
          id: 7,
          name: "Imprimante Laser 500W",
          image: "./images/printer2.png",
          watt: 500
        }
      ]
    },
    {
      id: 2,
      name: "Son & Image",
      image: "./images/tv.png",
      puissance: 100,
      multipleQuantity: true,
      quantity: 1,
      usage: 0,
      selectedOption: {},
      options: [
        {
          id: 0,
          name: "TV LED ECRAN PLAT 50W",
          image: "./images/tv1.png",
          watt: 50
        }, 
        {
          id: 1,
          name: "TV LED ECRAN PLAT 100W",
          image: "./images/tv2.png",
          watt: 100
        }, 
        {
          id: 2,
          name: "Enceinte Bluetooth 10W",
          image: "./images/bluetoothspk.png",
          watt: 10
        }, 
        {
          id: 3,
          name: "RADIO / MINI CHAINE 20W",
          image: "./images/radio1.png",
          watt: 20
        }, 
        {
          id: 4,
          name: "CHAINE HIFI 50W",
          image: "./images/chainehifi.png",
          watt: 50
        }
      ]
    },
    {
      id: 3,
      name: "Électroménager",
      image: "./images/home-appliance.png",
      multipleQuantity: false,
      quantity: 1,
      usage: 0,
      selectedOption: {},
      puissance: 100,
      totalGiven: true,
      options: [
        {
          id: 0,
          name: "MINI FRIGO A+ 40L/60L 12H/Jour: 600WH",
          image: "./images/minifrigo1.png",
          utilization: 12,
          watt: 600
        }, 
        {
          id: 1,
          name: "MINI FRIGO A+ 40L/60L 24H/Jour: 1000WH",
          image: "./images/minifrigo2.png",
          utilization: 24,
          watt: 1000
        }, 
        {
          id: 2,
          name: "FRIGO CONGEL A+ 200/300L :12H/Jour: 800WH",
          image: "./images/refrig1.png",
          utilization: 12,
          watt: 800
        }, 
        {
          id: 3,
          name: "FRIGO CONGEL A+ 200L/300L : 24H/Jour: 1400WH",
          image: "./images/refrig2.png",
          utilization: 24,
          watt: 1400
        }, 
        {
          id: 4,
          name: "FRIGO AMÉRICAIN A+ 24H/Jour: 1800WH",
          image: "./images/refrig1.png",
          utilization: 24,
          watt: 1800
        }, 
        {
          id: 5,
          name: "FRIGO ou Congélateur ANCIEN MODÈLE NON ÉCONOMIQUE 12H/Jour: 2000WH",
          image: "./images/refrig2.png",
          utilization: 12,
          watt: 2000
        }, 
        {
          id: 6,
          name: "FRIGO ou Congélateur ANCIEN MODÈLE NON ÉCONOMIQUE 24H/Jour: 4000WH",
          image: "./images/deepfreezer.png",
          utilization: 24,
          watt: 4000
        }
      ]
    },
    {
      id: 4,
      name: "Petit Électroménager",
      image: "./images/small-appliance.png",
      multipleQuantity: false,
      quantity: 1,
      usage: 0,
      selectedOption: {},
      options: [
        {
          id: 0,
          name: "Robot cuisine 500W",
          image: "./images/robot.png",
          watt: 500
        }, 
        {
          id: 1,
          name: "Machine à laver top 500W",
          image: "./images/washingmachine.png",
          watt: 500
        }, 
        {
          id: 2,
          name: "Ventilateur 50W",
          image: "./images/fan.png",
          watt: 50
        }
      ]
    },
    {
      id: 5,
      name: "Gros Électroménager",
      image: "./images/machinee.png",
      puissance: 200,
      selectedOption: {},
      multipleQuantity: false,
      showWarning: true,
      quantity: 1,
      usage: 0,
      options: [
        {
          id: 0,
          name: " Machine à laver hublot 2000W",
          image: "./images/washingmachine.png",
          watt: 2000
        }, 
        {
          id: 1,
          name: " Plaque à induction 1500W",
          image: "./images/plaqueinduc.png",
          watt: 1500
        }, 
        {
          id: 2,
          name: "Sèche-cheveux 1500W",
          image: "./images/dryer.png",
          watt: 1500
        }, 
        {
          id: 3,
          name: "Four 1500W",
          image: "./images/four.png",
          watt: 1500
        }, 
        {
          id: 4,
          name: "Cafetière / Bouilloire 1500W",
          image: "./images/cafe.png",
          watt: 1500
        }
      ]
    },
    {
      id: 6,
      name: "Pompage",
      image: "./images/pumping.png",
      puissance: 100,
      selectedOption: {},
      multipleQuantity: false,
      quantity: 1,
      usage: 0,
      options: [
        {
          id: 0,
          name: "Pompe 12/24V 200W",
          image: "./images/pomp1.png",
          watt: 200
        }, 
        {
          id: 1,
          name: "Pompe 220V 600W",
          image: "./images/pump2.png",
          watt: 600
        }, 
        {
          id: 2,
          name: "Pompe 220V 1000W",
          image: "./images/pomp3.png",
          watt: 1000
        }
      ]
    },
    {
      id: 7,
      name: "Sécurité",
      image: "./images/security.png",
      puissance: 100,
      selectedOption: {},
      multipleQuantity: false,
      quantity: 1,
      usage: 0,
      options: [
        {
          id: 0,
          name: "Alarme 30W",
          image: "./images/alaram.png",
          watt: 30
        }, 
        {
          id: 1,
          name: "Vidéosurveillance 30W",
          image: "./images/security.png",
          watt: 30
        }, 
        {
          id: 2,
          name: "Vidéosurveillance 50W",
          image: "./images/camera2.png",
          watt: 50
        }
      ]
    },
    {
      id: 8,
      name: "Personnalisé",
      image: "./images/custom.png",
      puissance: 100,
      canCustomize: true,
      multipleQuantity: false,
      quantity: 1,
      usage: 0,
      selectedOption: {},
      options: [
        {
          id: 0,
          name: "Puissance 50W",
          image: "./images/personalized.png",
          watt: 50
        },
        {
          id: 1,
          name: "Puissance 100W",
          image: "./images/personalized.png",
          watt: 100
        },
        {
          id: 2,
          name: "Puissance 200W",
          image: "./images/personalized.png",
          watt: 200
        },
        {
          id: 3,
          name: "Puissance 400W",
          image: "./images/personalized.png",
          watt: 400
        },
        {
          id: 4,
          name: "Puissance 500W",
          image: "./images/personalized.png",
          watt: 500
        },
        {
          id: 5,
          name: "Puissance 800W",
          image: "./images/personalized.png",
          watt: 800
        },
        {
          id: 6,
          name: "Puissance 1000W",
          image: "./images/personalized.png",
          watt: 1000
        }
      ]
    }
  ]
};

export default equipmentData;